// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__t65Be","contentWrapper":"styles_contentWrapper__lkKRB","card":"styles_card__5Vrry","subtitle":"styles_subtitle__bQJWh","disabled":"styles_disabled__Os1G6"};